import * as _ from 'lodash';
import { ColumnHandler } from '../types';
import { parseJson, parseDatetime, parseString } from '../converters';
import { LongTextColumnType } from '../../monday-api/api';

export type LongTextColumnValue = {
  text: string | null;
  changed_at: string | null;
};

const handler: ColumnHandler<LongTextColumnType, LongTextColumnValue> = {
  type: 'long_text',

  default_value_field: 'text',

  supported_rules: [
    {
      operator: 'any_of',
      compare_value_ids: ['empty_string', 'text'],
    },
    {
      operator: 'not_any_of',
      compare_value_ids: ['empty_string', 'text'],
    },
    {
      operator: 'is_empty',
      compare_value_ids: ['empty_null'],
    },
    {
      operator: 'is_not_empty',
      compare_value_ids: ['empty_null'],
    },
    {
      operator: 'contains_text',
      compare_value_ids: ['text'],
    },
    {
      operator: 'not_contains_text',
      compare_value_ids: ['text'],
    },
  ],

  convertValueFromMondayToEngine: (columnValue) => {
    const text = parseString(columnValue.text);
    const value = parseJson(columnValue.value);
    const changedAt = parseDatetime(_.get(value, 'changed_at'));

    return {
      text,
      changed_at: changedAt,
    };
  },

  convertValueFromEngineToUpdateValue: (engineValue) => {
    return engineValue.text;
  },

  getFormulaValue: (engineValue) => (engineValue.text === null ? '' : engineValue.text),
};

export default handler;
